document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".audio-preview").forEach((player) => {

    const wavesurfer = WaveSurfer.create({
      container: player.querySelector(".audio-preview__wave"),
      waveColor: "#9ca3af",
      progressColor: "#1f2937",
      cursorColor: "transparent",
      height: 40,
      barWidth: 2,
      barGap: 1,
      backend: "MediaElement",
      hideScrollbar: true
    });

    wavesurfer.load(player.dataset.audio);

    const button = player.querySelector(".audio-preview__play");
    const timeDisplay = player.querySelector(".audio-preview__time");

    function formatTime(seconds) {
      const m = Math.floor(seconds / 60);
      const s = Math.floor(seconds % 60).toString().padStart(2, "0");
      return `${m}:${s}`;
    }

    wavesurfer.on("ready", () => {
      timeDisplay.textContent = `0:00 / ${formatTime(wavesurfer.getDuration())}`;
    });

    wavesurfer.on("audioprocess", () => {
      timeDisplay.textContent = `${formatTime(wavesurfer.getCurrentTime())} / ${formatTime(wavesurfer.getDuration())}`;
    });

    wavesurfer.on("seek", () => {
      timeDisplay.textContent = `${formatTime(wavesurfer.getCurrentTime())} / ${formatTime(wavesurfer.getDuration())}`;
    });

    button.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      wavesurfer.playPause();
    });

    wavesurfer.on("play", () => { button.textContent = "❚❚"; });
    wavesurfer.on("pause", () => { button.textContent = "▶"; });

  });

});